import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight">
            {t('categories.title')}
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            {t('categories.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-4 p-4 rounded-xl bg-white border border-background-200 hover:border-primary-300 hover:shadow-md transition-all"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex flex-col min-w-0">
                <span className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-tight">
                  {cat.name}
                </span>
                <span className="mt-1 text-xs md:text-sm text-foreground-600 leading-snug">
                  {cat.desc}
                </span>
              </div>
              <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 ml-auto flex-shrink-0 transition-colors" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}